/// <reference path="wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var MetadataEditors;
    (function (MetadataEditors) {
        const LOG_CATEGORY = "WPT.MetadataEditors.WorkView";
        const TEXTAREA_MAXHEIGHT = "7em";
        let WorkViewEditMode;
        (function (WorkViewEditMode) {
            WorkViewEditMode["READONLY"] = "READONLY";
            WorkViewEditMode["RETRIEVAL"] = "RETRIEVAL";
            WorkViewEditMode["ARCHIVE"] = "ARCHIVE";
        })(WorkViewEditMode = MetadataEditors.WorkViewEditMode || (MetadataEditors.WorkViewEditMode = {}));
        class AttributeEditorWrapper {
            constructor(core, container, id, attribute) {
                this._core = null;
                this._log = null;
                this._id = null;
                this._container = null;
                this._attribute = null;
                this._labelDiv = null;
                this._label = null;
                this._editorLinks = null;
                this._editorDiv = null;
                this._editor = null;
                this.switchToEdit = () => {
                    this._log.info("AttributeEditorWrapper.switchToEdit()");
                    if (!this.Editor.IsEditable) {
                        return;
                    }
                    this._core.Functions.showElement(this._editorLinks);
                    this.Editor.switchToEdit();
                };
                this._createWrapper = () => {
                    let wrapperItem = document.createElement('li');
                    wrapperItem.classList.add('wpt-form-item');
                    this._labelDiv = document.createElement('div');
                    wrapperItem.appendChild(this._labelDiv);
                    this._labelDiv.classList.add('wpt-form-item-label');
                    this._label = document.createElement('label');
                    this._labelDiv.appendChild(this._label);
                    this._label.classList.add('wpt-form-item-label__text');
                    this._label.id = this._id;
                    let labelText = null;
                    if (this._attribute.DisplayName != null) {
                        labelText = this._attribute.DisplayName;
                    }
                    else {
                        labelText = this._attribute.Name;
                    }
                    this._label.innerText = labelText;
                    this._editorLinks = document.createElement('div');
                    this._labelDiv.appendChild(this._editorLinks);
                    this._editorLinks.classList.add('wpt-form-item-label__edit-links', WPTNamespace.HIDDEN_CLASS);
                    if (this._attribute.DataType == 'Boolean') {
                        this._editorLinks.classList.remove(WPTNamespace.HIDDEN_CLASS);
                    }
                    this._editorDiv = document.createElement('div');
                    wrapperItem.appendChild(this._editorDiv);
                    this._editorDiv.classList.add('wpt-form-item__editor');
                    this._container.appendChild(wrapperItem);
                };
                this._core = core;
                this._log = core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("AttributeEditorWrapper::constructor");
                this._id = id;
                this._container = container;
                this._attribute = attribute;
                this._createWrapper();
            }
            get Editor() {
                return this._editor;
            }
            set Editor(editor) {
                this._editor = editor;
                if (this._attribute.Required && editor.IsEditable) {
                    this._label.classList.add('wpt-form-item-label__text--required');
                }
            }
            get EditorDiv() {
                return this._editorDiv;
            }
            get EditorLinksSpan() {
                return this._editorLinks;
            }
        }
        MetadataEditors.AttributeEditorWrapper = AttributeEditorWrapper;
        class AttributeEditor {
            constructor(core, form, container, id, attribute, callbacks = {}, edit = WorkViewEditMode.READONLY) {
                this._core = null;
                this._log = null;
                this._form = null;
                this._container = null;
                this._id = null;
                this._attribute = null;
                this._editMode = null;
                this._originalValue = null;
                this._currentValue = null;
                this._isValid = null;
                this._hasEditLinks = null;
                this._editLinks = null;
                this._callbacks = null;
                this.switchToEdit = () => {
                    this._log.info("AttributeEditor.switchToEdit()");
                    if (!this.IsEditable) {
                        return;
                    }
                    this._allowEditing();
                };
                this._core = core;
                this._log = core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("AttributeEditor::constructor");
                this._form = form;
                this._container = container;
                this._id = id;
                this._attribute = attribute;
                this._callbacks = callbacks;
                this._editMode = edit;
                this._isValid = true;
                this._hasEditLinks = false;
                this._originalValue = this._attribute.Value;
                this._currentValue = this._attribute.Value;
            }
            get AttributeName() {
                return this._attribute.Name;
            }
            get HasEditLinks() {
                return this._hasEditLinks;
            }
            get EditLinks() {
                return this._editLinks;
            }
            get IsEditable() {
                return this._editMode != WorkViewEditMode.READONLY && !this._attribute.Readonly;
            }
        }
        MetadataEditors.AttributeEditor = AttributeEditor;
        class AttributeEditorFactory {
        }
        AttributeEditorFactory._log = null;
        AttributeEditorFactory.createAttributeWrapper = (core, form, container, id, attribute, callbacks = {}, edit = WorkViewEditMode.READONLY) => {
            AttributeEditorFactory._initLogger(core);
            AttributeEditorFactory._log.info("AttributeEditorFactory.createAttributeWrapper()");
            let wrapper = new MetadataEditors.AttributeEditorWrapper(core, container, id, attribute);
            wrapper.Editor = MetadataEditors.AttributeEditorFactory.createAttributeEditor(core, form, wrapper.EditorDiv, id, attribute, callbacks, edit);
            if (wrapper.Editor.HasEditLinks) {
                wrapper.EditorLinksSpan.appendChild(wrapper.Editor.EditLinks);
            }
            return wrapper;
        };
        AttributeEditorFactory.createAttributeEditor = (core, form, container, id, attribute, callbacks = {}, edit = WorkViewEditMode.READONLY) => {
            AttributeEditorFactory._initLogger(core);
            AttributeEditorFactory._log.info("AttributeEditorFactory.createAttributeEditor()");
            let result = null;
            switch (attribute.DataType) {
                case 'Boolean':
                    result = new BooleanAttributeEditor(core, form, container, id, attribute, callbacks, edit);
                    break;
                case 'Date':
                    result = new DateAttributeEditor(core, form, container, id, attribute, callbacks, edit);
                    break;
                case 'DateTime':
                    result = new DateTimeAttributeEditor(core, form, container, id, attribute, callbacks, edit);
                    break;
                case 'Integer':
                    result = new NumberAttributeEditor(core, form, container, id, attribute, "1", false, callbacks, edit);
                    break;
                case 'Currency':
                    result = new NumberAttributeEditor(core, form, container, id, attribute, "0.01", true, callbacks, edit);
                    break;
                case 'Float':
                case 'Decimal':
                    result = new NumberAttributeEditor(core, form, container, id, attribute, "0.000001", false, callbacks, edit);
                    break;
                case 'Text':
                    result = new TextAttributeEditor(core, form, container, id, attribute, callbacks, edit);
                    break;
                case 'FormattedText':
                    result = new FormattedTextAttributeEditor(core, form, container, id, attribute, callbacks, edit);
                    break;
                case 'Relation':
                    result = new RelationAttributeEditor(core, form, container, id, attribute, callbacks, edit);
                    break;
                case 'Document':
                    result = new DocumentAttributeEditor(core, form, container, id, attribute, callbacks, edit);
                    break;
                case "Alphanumeric":
                default:
                    result = new AlphanumericAttributeEditor(core, form, container, id, attribute, callbacks, edit);
                    break;
            }
            return result;
        };
        AttributeEditorFactory._initLogger = (core) => {
            if (AttributeEditorFactory._log === null) {
                AttributeEditorFactory._log = core.Logging.getLogger(LOG_CATEGORY);
            }
        };
        MetadataEditors.AttributeEditorFactory = AttributeEditorFactory;
        class AlphanumericAttributeEditor extends AttributeEditor {
            constructor(core, form, container, id, attribute, callbacks = {}, edit = WorkViewEditMode.READONLY) {
                super(core, form, container, id, attribute, callbacks, edit);
                this._inputDiv = null;
                this._input = null;
                this._selectDiv = null;
                this._selectComponent = null;
                this.getChangedValue = () => {
                    this._log.info("AlphanumericAttributeEditor.getChangedValue()");
                    if (this._originalValue != this._currentValue) {
                        let result = {
                            Name: this._attribute.Name,
                            DataType: this._attribute.DataType,
                            Value: this._currentValue
                        };
                        return result;
                    }
                    return null;
                };
                this.setValue = (value) => {
                    this._log.info("AlphanumericAttributeEditor.setValue()");
                    if (this._attribute.Dataset) {
                        this._selectComponent.Input.value = value;
                    }
                    this._input.value = value;
                    this._currentValue = value;
                };
                this._allowEditing = () => {
                    this._log.info("AlphanumericAttributeEditor._allowEditing()");
                    if (this._attribute.Dataset) {
                        this._core.Functions.hideElement(this._inputDiv);
                        this._core.Functions.showElement(this._selectDiv);
                        if (this._attribute.Required) {
                            this._selectComponent.Input.required = true;
                        }
                    }
                    else {
                        this._core.Functions.setInputAbility(this._inputDiv, true, this._input);
                        if (this._attribute.DataLength && this._attribute.DataLength > 0) {
                            this._input.maxLength = this._attribute.DataLength;
                        }
                        if (this._attribute.Required) {
                            this._input.required = true;
                        }
                        // on change check validity
                        this._input.addEventListener('change', this._valueChanged);
                        // switching between display and editing inputs
                        this._input.addEventListener('blur', this._displayText);
                    }
                };
                this._createInput = () => {
                    this._log.info("AlphanumericAttributeEditor._createInput()");
                    this._inputDiv = document.createElement('div');
                    this._inputDiv.classList.add("wpt-input", "wpt-input--full");
                    this._input = document.createElement('input');
                    this._inputDiv.appendChild(this._input);
                    this._input.setAttribute('aria-labelledby', this._id);
                    this._input.classList.add('wpt-input__input');
                    this._input.type = 'text';
                    this._input.value = this._attribute.Value;
                    this._core.Functions.setInputAbility(this._inputDiv, false, this._input);
                    this._container.appendChild(this._inputDiv);
                    if (this._attribute.Dataset) {
                        this._selectDiv = document.createElement('div');
                        this._selectDiv.classList.add("wpt-input", "wpt-input--full", WPTNamespace.HIDDEN_CLASS);
                        let dataSet = {
                            Items: []
                        };
                        let wvDataset = this._core.OBHelper.WorkViewDatasets.find(ds => ds.Name == this._attribute.Dataset);
                        if (wvDataset) {
                            wvDataset.Values.forEach(value => {
                                dataSet.Items.push({ Id: value, DisplayName: value });
                            });
                        }
                        let selectOpts = {
                            Options: dataSet,
                            ValueMustExist: true,
                            AllowEmptyValue: true,
                            ChangeCallback: this._selectChanged
                        };
                        this._selectComponent = new WPTNamespace.Widgets.ComponentOptionInput(this._core, this._selectDiv, null, selectOpts);
                        this._selectComponent.present();
                        this._selectComponent.Input.setAttribute('aria-labelledby', this._id);
                        if (this._attribute.DataLength && this._attribute.DataLength > 0) {
                            this._selectComponent.Input.maxLength = this._attribute.DataLength;
                        }
                        this._selectComponent.Input.value = this._attribute.Value;
                        // switching between display and editing inputs
                        this._selectComponent.Input.addEventListener('blur', this._displayText);
                        this._container.appendChild(this._selectDiv);
                    }
                };
                this._selectChanged = (event) => {
                    this._log.info("AlphanumericAttributeEditor._selectChanged()");
                    event === null || event === void 0 ? void 0 : event.preventDefault();
                    if (this._selectComponent.Input.checkValidity()) {
                        this._isValid = true;
                        this._currentValue = this._selectComponent.Input.value;
                        if (this._callbacks.DataChangedCallback) {
                            this._callbacks.DataChangedCallback();
                        }
                    }
                    else {
                        this._isValid = false;
                        this._form.reportValidity();
                    }
                };
                this._valueChanged = (event) => {
                    this._log.info("AlphanumericAttributeEditor._valueChanged()");
                    event === null || event === void 0 ? void 0 : event.preventDefault();
                    if (this._input.checkValidity()) {
                        this._isValid = true;
                        this._currentValue = this._input.value;
                        if (this._callbacks.DataChangedCallback) {
                            this._callbacks.DataChangedCallback();
                        }
                    }
                    else {
                        this._isValid = false;
                        this._form.reportValidity();
                    }
                };
                this._displayText = (event) => {
                    this._log.info("AlphanumericAttributeEditor._displayText()");
                    event.preventDefault();
                    if (!this._isValid) {
                        this._form.reportValidity();
                    }
                };
                this._createInput();
            }
        }
        class BooleanAttributeEditor extends AttributeEditor {
            constructor(core, form, container, id, attribute, callbacks = {}, edit = WorkViewEditMode.READONLY) {
                super(core, form, container, id, attribute, callbacks, edit);
                this._inputDiv = null;
                this._input = null;
                this._display = null;
                this.getChangedValue = () => {
                    this._log.info("BooleanAttributeEditor.getChangedValue()");
                    if (this._originalValue != this._currentValue) {
                        let result = {
                            Name: this._attribute.Name,
                            DataType: this._attribute.DataType,
                            Value: this._currentValue
                        };
                        return result;
                    }
                    return null;
                };
                this.setValue = (value) => {
                    this._log.info("BooleanAttributeEditor.setValue()");
                    this._currentValue = value;
                    switch (this._currentValue) {
                        case 'TRUE':
                            this._input.checked = true;
                            this._input.removeAttribute('aria-checked');
                            this._display.classList.add('wpt-boolean--true', 'wpt-font-icon_OK');
                            break;
                        case 'FALSE':
                            this._input.checked = false;
                            this._input.removeAttribute('aria-checked');
                            this._display.classList.add('wpt-boolean--false', 'wpt-font-icon_CloseCircle');
                            break;
                        default:
                            this._input.indeterminate = true;
                            this._input.setAttribute('aria-checked', 'mixed');
                            this._display.classList.add('wpt-font-icon_QuestionCircle');
                            break;
                    }
                };
                this._allowEditing = () => {
                    this._log.info("BooleanAttributeEditor._allowEditing()");
                    this._core.Functions.showElement(this._input);
                    this._core.Functions.hideElement(this._display);
                    if (this._attribute.Required) {
                        this._input.required = true;
                    }
                };
                this._createInput = () => {
                    this._log.info("BooleanAttributeEditor._createInput()");
                    this._editLinks = document.createDocumentFragment();
                    this._hasEditLinks = true;
                    this._inputDiv = document.createElement('div');
                    this._editLinks.appendChild(this._inputDiv);
                    this._inputDiv.classList.add("wpt-input", "wpt-input--no-border");
                    this._display = document.createElement('span');
                    this._inputDiv.appendChild(this._display);
                    this._display.setAttribute('aria-labelledby', this._id);
                    this._display.classList.add('wpt-boolean', 'wpt-font');
                    if (this._currentValue == 'TRUE') {
                        this._display.classList.add('wpt-boolean--true', 'wpt-font-icon_OK');
                    }
                    else if (this._currentValue == 'FALSE') {
                        this._display.classList.add('wpt-boolean--false', 'wpt-font-icon_CloseCircle');
                    }
                    else {
                        this._display.classList.add('wpt-font-icon_QuestionCircle');
                    }
                    if (this.IsEditable) {
                        this._input = document.createElement('input');
                        this._inputDiv.appendChild(this._input);
                        this._input.setAttribute('aria-labelledby', this._id);
                        this._input.classList.add('wpt-input__input', WPTNamespace.HIDDEN_CLASS);
                        this._input.type = 'checkbox';
                        this._input.value = this._attribute.Value;
                        switch (this._currentValue) {
                            case 'TRUE':
                                this._input.checked = true;
                                break;
                            case 'FALSE':
                                this._input.checked = false;
                                break;
                            default:
                                this._input.indeterminate = true;
                                this._input.setAttribute('aria-checked', 'mixed');
                                break;
                        }
                        // on change check validity
                        this._input.addEventListener('change', this._valueChanged);
                    }
                };
                this._valueChanged = (event) => {
                    this._log.info("BooleanAttributeEditor._valueChanged()");
                    event === null || event === void 0 ? void 0 : event.preventDefault();
                    if (this._input.checkValidity()) {
                        this._isValid = true;
                        this._currentValue = this._input.checked ? 'TRUE' : 'FALSE';
                        this._input.removeAttribute('aria-checked');
                        if (this._callbacks.DataChangedCallback) {
                            this._callbacks.DataChangedCallback();
                        }
                    }
                    else {
                        this._isValid = false;
                        this._form.reportValidity();
                    }
                };
                this._createInput();
            }
        }
        class NumberAttributeEditor extends AttributeEditor {
            constructor(core, form, container, id, attribute, step, isCurrency, callbacks = {}, edit = WorkViewEditMode.READONLY) {
                super(core, form, container, id, attribute, callbacks, edit);
                this._inputDiv = null;
                this._display = null;
                this._input = null;
                this._step = null;
                this._isCurrency = null;
                this.getChangedValue = () => {
                    this._log.info("NumberAttributeEditor.getChangedValue()");
                    if (this._originalValue != this._currentValue) {
                        let result = {
                            Name: this._attribute.Name,
                            DataType: this._attribute.DataType,
                            Value: this._currentValue
                        };
                        return result;
                    }
                    return null;
                };
                this.setValue = (value) => {
                    this._log.info("NumberAttributeEditor.setValue()");
                    this._currentValue = value;
                    this._input.value = value;
                    this._display.value = this._getValueString(value);
                };
                this._allowEditing = () => {
                    this._log.info("NumberAttributeEditor._allowEditing()");
                    this._core.Functions.setInputAbility(this._inputDiv, true, this._display);
                    if (this._attribute.Required) {
                        this._input.required = true;
                    }
                    // on change check validity
                    this._input.addEventListener('change', this._numberChanged);
                    // switching between display and editing inputs
                    this._display.addEventListener('focus', this._editNumber);
                    this._input.addEventListener('blur', this._displayNumber);
                };
                this._createInput = () => {
                    this._log.info("NumberAttributeEditor._createInput()");
                    this._inputDiv = document.createElement('div');
                    this._inputDiv.classList.add("wpt-input", "wpt-input--full");
                    this._display = document.createElement('input');
                    this._inputDiv.appendChild(this._display);
                    this._display.setAttribute('aria-labelledby', this._id);
                    this._display.classList.add('wpt-input__input');
                    this._display.type = 'text';
                    this._display.value = this._getValueString(this._attribute.Value);
                    this._core.Functions.setInputAbility(this._inputDiv, false, this._display);
                    if (this.IsEditable) {
                        this._input = document.createElement('input');
                        this._inputDiv.appendChild(this._input);
                        this._input.setAttribute('aria-labelledby', this._id);
                        this._input.classList.add('wpt-input__input', WPTNamespace.HIDDEN_CLASS);
                        this._input.type = 'number';
                        this._input.step = this._step;
                        this._input.value = this._attribute.Value;
                    }
                    this._container.appendChild(this._inputDiv);
                };
                this._getValueString = (value) => {
                    this._log.info("NumberAttributeEditor._getValueString()");
                    let valueString = "";
                    if (value != "") {
                        if (this._isCurrency) {
                            valueString = this._core.OBHelper.formatCurrency(value);
                        }
                        else {
                            valueString = this._core.OBHelper.formatNumber(value);
                        }
                    }
                    return valueString;
                };
                this._numberChanged = (event) => {
                    this._log.info("NumberAttributeEditor._numberChanged()");
                    event.preventDefault();
                    if (this._input.checkValidity()) {
                        this._isValid = true;
                        this._currentValue = this._input.value;
                        this._display.value = this._getValueString(this._input.value);
                        if (this._callbacks.DataChangedCallback) {
                            this._callbacks.DataChangedCallback();
                        }
                    }
                    else {
                        this._isValid = false;
                        this._form.reportValidity();
                    }
                };
                this._displayNumber = (event) => {
                    this._log.info("NumberAttributeEditor._displayNumber()");
                    event.preventDefault();
                    if (this._isValid) {
                        this._core.Functions.hideElement(this._input);
                        this._core.Functions.showElement(this._display);
                    }
                    else {
                        this._form.reportValidity();
                    }
                };
                this._editNumber = (event) => {
                    this._log.info("NumberAttributeEditor._editNumber()");
                    event.preventDefault();
                    this._core.Functions.showElement(this._input);
                    this._core.Functions.hideElement(this._display);
                    this._input.focus();
                };
                this._step = step;
                this._isCurrency = isCurrency;
                this._createInput();
            }
        }
        class DateAttributeEditor extends AttributeEditor {
            constructor(core, form, container, id, attribute, callbacks = {}, edit = WorkViewEditMode.READONLY) {
                super(core, form, container, id, attribute, callbacks, edit);
                this._inputDiv = null;
                this._display = null;
                this._input = null;
                this.getChangedValue = () => {
                    this._log.info("DateAttributeEditor.getChangedValue()");
                    if (this._originalValue != this._currentValue) {
                        let result = {
                            Name: this._attribute.Name,
                            DataType: this._attribute.DataType,
                            Value: this._currentValue
                        };
                        return result;
                    }
                    return null;
                };
                this.setValue = (value) => {
                    this._log.info("DateAttributeEditor.setValue()");
                    this._currentValue = value;
                    this._input.value = value;
                    this._display.value = this._getValueString(value);
                };
                this._allowEditing = () => {
                    this._log.info("DateAttributeEditor._allowEditing()");
                    this._core.Functions.setInputAbility(this._inputDiv, true, this._display);
                    if (this._attribute.Required) {
                        this._input.required = true;
                    }
                    // on change check validity
                    this._input.addEventListener('change', this._dateChanged);
                    // switching between display and editing inputs
                    this._display.addEventListener('focus', this._editDate);
                    this._input.addEventListener('blur', this._displayDate);
                };
                this._createInput = () => {
                    this._log.info("DateAttributeEditor._createInput()");
                    this._inputDiv = document.createElement('div');
                    this._inputDiv.classList.add("wpt-input", "wpt-input--full");
                    this._display = document.createElement('input');
                    this._inputDiv.appendChild(this._display);
                    this._display.setAttribute('aria-labelledby', this._id);
                    this._display.classList.add('wpt-input__input');
                    this._display.type = 'text';
                    this._display.value = this._getValueString(this._attribute.Value);
                    this._core.Functions.setInputAbility(this._inputDiv, false, this._display);
                    if (this.IsEditable) {
                        this._input = document.createElement('input');
                        this._inputDiv.appendChild(this._input);
                        this._input.setAttribute('aria-labelledby', this._id);
                        this._input.classList.add('wpt-input__input', WPTNamespace.HIDDEN_CLASS);
                        this._input.type = 'date';
                        this._input.value = this._attribute.Value;
                    }
                    this._container.appendChild(this._inputDiv);
                };
                this._getValueString = (value) => {
                    this._log.info("DateAttributeEditor._getValueString()");
                    let valueString = "";
                    if (value != "") {
                        valueString = this._core.OBHelper.formatDate(value);
                    }
                    return valueString;
                };
                this._dateChanged = (event) => {
                    this._log.info("DateAttributeEditor._dateChanged()");
                    event.preventDefault();
                    if (this._input.checkValidity()) {
                        this._isValid = true;
                        this._currentValue = this._input.value;
                        this._display.value = this._getValueString(this._input.value);
                        if (this._callbacks.DataChangedCallback) {
                            this._callbacks.DataChangedCallback();
                        }
                    }
                    else {
                        this._isValid = false;
                        this._form.reportValidity();
                    }
                };
                this._displayDate = (event) => {
                    this._log.info("DateAttributeEditor._displayDate()");
                    event.preventDefault();
                    if (this._isValid) {
                        this._core.Functions.hideElement(this._input);
                        this._core.Functions.showElement(this._display);
                    }
                    else {
                        this._form.reportValidity();
                    }
                };
                this._editDate = (event) => {
                    this._log.info("DateAttributeEditor._editDate()");
                    event.preventDefault();
                    this._core.Functions.showElement(this._input);
                    this._core.Functions.hideElement(this._display);
                    this._input.focus();
                };
                this._createInput();
            }
        }
        class DateTimeAttributeEditor extends AttributeEditor {
            constructor(core, form, container, id, attribute, callbacks = {}, edit = WorkViewEditMode.READONLY) {
                super(core, form, container, id, attribute, callbacks, edit);
                this._inputDiv = null;
                this._iconDiv = null;
                this._display = null;
                this._dateInput = null;
                this._timeInput = null;
                this.getChangedValue = () => {
                    this._log.info("DateTimeAttributeEditor.getChangedValue()");
                    if (this._originalValue != this._currentValue) {
                        let result = {
                            Name: this._attribute.Name,
                            DataType: this._attribute.DataType,
                            Value: this._currentValue
                        };
                        return result;
                    }
                    return null;
                };
                this.setValue = (value) => {
                    this._log.info("DateTimeAttributeEditor.setValue()");
                    this._currentValue = value;
                    let dtStringValues = ["", ""];
                    if (value != "") {
                        dtStringValues = value.split("T");
                    }
                    this._dateInput.value = dtStringValues[0];
                    this._timeInput.value = dtStringValues[1];
                    this._display.value = this._getValueString(value);
                };
                this._allowEditing = () => {
                    this._log.info("DateTimeAttributeEditor._allowEditing()");
                    this._core.Functions.setInputAbility(this._inputDiv, true, this._display);
                    this._core.Functions.showElement(this._iconDiv);
                    if (this._attribute.Required) {
                        this._dateInput.required = true;
                        this._timeInput.required = true;
                    }
                    // on change check validity
                    this._dateInput.addEventListener('change', this._datetimeChanged);
                    this._timeInput.addEventListener('change', this._datetimeChanged);
                    // switching between display and editing inputs
                    this._display.addEventListener('focus', this._editDate);
                    this._dateInput.addEventListener('blur', this._displayDatetime);
                    this._timeInput.addEventListener('blur', this._displayDatetime);
                };
                this._createInput = () => {
                    this._log.info("DateTimeAttributeEditor._createInput()");
                    this._inputDiv = document.createElement('div');
                    this._inputDiv.classList.add("wpt-input", "wpt-input--full");
                    if (this.IsEditable) {
                        this._iconDiv = document.createElement('div');
                        this._inputDiv.appendChild(this._iconDiv);
                        this._iconDiv.classList.add('wpt-input__icons', 'wpt-input__icons--first', WPTNamespace.HIDDEN_CLASS);
                        let dateSpan = document.createElement('span');
                        this._iconDiv.appendChild(dateSpan);
                        dateSpan.classList.add("wpt-input__icons-item", "wpt-input__icons-item--gap-to-right", "wpt-input__icons-item--hover-primary", 'wpt-font', 'wpt-font-icon_Calendar');
                        dateSpan.addEventListener('click', this._editDate);
                        let timeSpan = document.createElement('span');
                        this._iconDiv.appendChild(timeSpan);
                        timeSpan.classList.add("wpt-input__icons-item", "wpt-input__icons-item--hover-primary", 'wpt-font', 'wpt-font-icon_History');
                        timeSpan.addEventListener('click', this._editTime);
                    }
                    this._display = document.createElement('input');
                    this._inputDiv.appendChild(this._display);
                    this._display.setAttribute('aria-labelledby', this._id);
                    this._display.classList.add('wpt-input__input');
                    this._display.type = 'text';
                    this._display.value = this._getValueString(this._attribute.Value);
                    this._core.Functions.setInputAbility(this._inputDiv, false, this._display);
                    if (this.IsEditable) {
                        let dtStringValues = ["", ""];
                        if (this._attribute.Value != "") {
                            dtStringValues = this._attribute.Value.split("T");
                        }
                        this._dateInput = document.createElement('input');
                        this._inputDiv.appendChild(this._dateInput);
                        this._dateInput.setAttribute('aria-labelledby', this._id);
                        this._dateInput.classList.add('wpt-input__input', WPTNamespace.HIDDEN_CLASS);
                        this._dateInput.type = 'date';
                        this._dateInput.value = dtStringValues[0];
                        this._timeInput = document.createElement('input');
                        this._inputDiv.appendChild(this._timeInput);
                        this._timeInput.setAttribute('aria-labelledby', this._id);
                        this._timeInput.classList.add('wpt-input__input', WPTNamespace.HIDDEN_CLASS);
                        this._timeInput.type = 'time';
                        // allow seconds for time input
                        this._timeInput.step = '1';
                        this._timeInput.value = dtStringValues[1];
                    }
                    this._container.appendChild(this._inputDiv);
                };
                this._getValue = () => {
                    this._log.info("DateTimeAttributeEditor._getValue()");
                    let result = "";
                    if (this._dateInput.value != "") {
                        result = this._dateInput.value;
                        let timeValue = this._timeInput.value;
                        if (timeValue == "") {
                            timeValue = "00:00:00";
                        }
                        result += "T" + timeValue;
                    }
                    return result;
                };
                this._getValueString = (value) => {
                    this._log.info("DateTimeAttributeEditor._getValueString()");
                    let valueString = "";
                    if (value != "") {
                        valueString = this._core.OBHelper.formatDatetime(value);
                    }
                    return valueString;
                };
                this._datetimeChanged = (event) => {
                    this._log.info("DateTimeAttributeEditor._datetimeChanged()");
                    event.preventDefault();
                    if (this._dateInput.checkValidity() && this._timeInput.checkValidity()) {
                        this._isValid = true;
                        this._currentValue = this._getValue();
                        this._display.value = this._getValueString(this._currentValue);
                        if (this._callbacks.DataChangedCallback) {
                            this._callbacks.DataChangedCallback();
                        }
                    }
                    else {
                        this._isValid = false;
                        this._form.reportValidity();
                    }
                };
                this._displayDatetime = (event) => {
                    this._log.info("DateTimeAttributeEditor._displayDatetime()");
                    event.preventDefault();
                    if (event.relatedTarget == null || (event.relatedTarget != this._dateInput && event.relatedTarget != this._timeInput)) {
                        if (this._isValid) {
                            this._core.Functions.hideElement(this._dateInput);
                            this._core.Functions.hideElement(this._timeInput);
                            this._core.Functions.showElement(this._display);
                        }
                        else {
                            this._form.reportValidity();
                        }
                    }
                };
                this._editDate = (event) => {
                    this._log.info("DateTimeAttributeEditor._editDate()");
                    event.preventDefault();
                    this._core.Functions.showElement(this._dateInput);
                    this._core.Functions.showElement(this._timeInput);
                    this._core.Functions.hideElement(this._display);
                    this._dateInput.focus();
                };
                this._editTime = (event) => {
                    this._log.info("DateTimeAttributeEditor._editTime()");
                    event.preventDefault();
                    this._core.Functions.showElement(this._dateInput);
                    this._core.Functions.showElement(this._timeInput);
                    this._core.Functions.hideElement(this._display);
                    this._timeInput.focus();
                };
                this._createInput();
            }
        }
        class TextAttributeEditor extends AttributeEditor {
            constructor(core, form, container, id, attribute, callbacks = {}, edit = WorkViewEditMode.READONLY) {
                super(core, form, container, id, attribute, callbacks, edit);
                this._inputDiv = null;
                this._resizeObserver = null;
                this._borderHeight = null;
                this.getChangedValue = () => {
                    this._log.info("TextAttributeEditor.getChangedValue()");
                    if (this._originalValue != this._currentValue) {
                        let result = {
                            Name: this._attribute.Name,
                            DataType: this._attribute.DataType,
                            Value: this._currentValue
                        };
                        return result;
                    }
                    return null;
                };
                this.setValue = (value) => {
                    this._log.info("TextAttributeEditor.setValue()");
                    this._currentValue = value;
                    this._input.value = value;
                };
                this._allowEditing = () => {
                    this._log.info("TextAttributeEditor._allowEditing()");
                    this._core.Functions.setInputAbility(this._inputDiv, true, this._input);
                    if (this._attribute.Required) {
                        this._input.required = true;
                    }
                    // on change check validity
                    this._input.addEventListener('change', this._valueChanged);
                    // switching between display and editing inputs
                    this._input.addEventListener('blur', this._displayText);
                };
                this._createInput = () => {
                    this._log.info("TextAttributeEditor._createInput()");
                    this._inputDiv = document.createElement('div');
                    this._inputDiv.classList.add("wpt-input", "wpt-input--full");
                    this._input = document.createElement('textarea');
                    this._inputDiv.appendChild(this._input);
                    this._input.setAttribute('aria-labelledby', this._id);
                    this._input.classList.add('wpt-input__input', 'wpt-input__input--text');
                    this._input.rows = 1;
                    this._input.value = this._attribute.Value;
                    this._core.Functions.setInputAbility(this._inputDiv, false, this._input);
                    if (window.ResizeObserver) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("TextAttributeEditor._createInput(): browser supports ResizeObserver");
                        }
                        this._resizeObserver = new ResizeObserver(this._setHeight);
                        this._resizeObserver.observe(this._input);
                    }
                    else {
                        console.warn("browser doesn't support ResizeObserver");
                    }
                    this._container.appendChild(this._inputDiv);
                };
                this._setHeight = () => {
                    this._log.info("TextAttributeEditor._setHeight()");
                    let height = this._input.scrollHeight;
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("TextAttributeEditor._setHeight(): got scrollHeight: " + height);
                    }
                    if (this._borderHeight === null) {
                        this._borderHeight = this._core.Functions.getElementBorderHeight(this._input);
                    }
                    height += this._borderHeight;
                    this._input.style.height = "min(" + TEXTAREA_MAXHEIGHT + "," + height + "px)";
                };
                this._valueChanged = (event) => {
                    this._log.info("TextAttributeEditor._valueChanged()");
                    event === null || event === void 0 ? void 0 : event.preventDefault();
                    if (this._input.checkValidity()) {
                        this._isValid = true;
                        this._currentValue = this._input.value;
                        if (this._callbacks.DataChangedCallback) {
                            this._callbacks.DataChangedCallback();
                        }
                    }
                    else {
                        this._isValid = false;
                        this._form.reportValidity();
                    }
                };
                this._displayText = (event) => {
                    this._log.info("TextAttributeEditor._displayText()");
                    event.preventDefault();
                    if (!this._isValid) {
                        this._form.reportValidity();
                    }
                    else {
                        this._setHeight();
                    }
                };
                this._createInput();
            }
        }
        class FormattedTextAttributeEditor extends AttributeEditor {
            constructor(core, form, container, id, attribute, callbacks = {}, edit = WorkViewEditMode.READONLY) {
                super(core, form, container, id, attribute, callbacks, edit);
                this._inputDiv = null;
                this._resizeObserver = null;
                this._borderHeight = null;
                this.getChangedValue = () => {
                    this._log.info("FormattedTextAttributeEditor.getChangedValue()");
                    if (this._originalValue != this._currentValue) {
                        let result = {
                            Name: this._attribute.Name,
                            DataType: this._attribute.DataType,
                            Value: this._currentValue
                        };
                        return result;
                    }
                    return null;
                };
                this.setValue = (value) => {
                    this._log.info("FormattedTextAttributeEditor.setValue()");
                    this._currentValue = value;
                    this._input.value = value;
                };
                this._allowEditing = () => {
                    this._log.info("FormattedTextAttributeEditor._allowEditing()");
                    // no editing for formatted text attributes
                };
                this._createInput = () => {
                    this._log.info("FormattedTextAttributeEditor._createInput()");
                    this._inputDiv = document.createElement('div');
                    this._inputDiv.classList.add("wpt-input", "wpt-input--full");
                    this._input = document.createElement('textarea');
                    this._inputDiv.appendChild(this._input);
                    this._input.setAttribute('aria-labelledby', this._id);
                    this._input.classList.add('wpt-input__input', 'wpt-input__input--text');
                    this._input.rows = 1;
                    this._input.value = this._attribute.Value;
                    this._core.Functions.setInputAbility(this._inputDiv, false, this._input);
                    if (window.ResizeObserver) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("FormattedTextAttributeEditor._createInput(): browser supports ResizeObserver");
                        }
                        this._resizeObserver = new ResizeObserver(this._setHeight);
                        this._resizeObserver.observe(this._input);
                    }
                    else {
                        console.warn("browser doesn't support ResizeObserver");
                    }
                    this._container.appendChild(this._inputDiv);
                };
                this._setHeight = () => {
                    this._log.info("FormattedTextAttributeEditor._setHeight()");
                    let height = this._input.scrollHeight;
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("FormattedTextAttributeEditor._setHeight(): got scrollHeight: " + height);
                    }
                    if (this._borderHeight === null) {
                        this._borderHeight = this._core.Functions.getElementBorderHeight(this._input);
                    }
                    height += this._borderHeight;
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("FormattedTextAttributeEditor._setHeight(): got border height: " + this._borderHeight);
                        this._log.trace("FormattedTextAttributeEditor._setHeight(): setting height: " + height);
                    }
                    this._input.style.height = "min(" + TEXTAREA_MAXHEIGHT + "," + height + "px)";
                };
                this._createInput();
            }
        }
        class DocumentAttributeEditor extends AttributeEditor {
            constructor(core, form, container, id, attribute, callbacks = {}, edit = WorkViewEditMode.READONLY) {
                var _a;
                super(core, form, container, id, attribute, callbacks, edit);
                this._inputDiv = null;
                this._input = null;
                this._iconDiv = null;
                this._linkSpan = null;
                this.getChangedValue = () => {
                    this._log.info("DocumentAttributeEditor.getChangedValue()");
                    if (this._originalValue != this._currentValue) {
                        let result = {
                            Name: this._attribute.Name,
                            DataType: this._attribute.DataType,
                            Value: this._currentValue
                        };
                        return result;
                    }
                    return null;
                };
                this.setValue = (value) => {
                    this._log.info("DocumentAttributeEditor.setValue()");
                    console.warn("setValue() not supported for Document attributes");
                };
                this._allowEditing = () => {
                    this._log.info("DocumentAttributeEditor._allowEditing()");
                    // no editing for document attributes
                };
                this._createInput = () => {
                    var _a, _b;
                    this._log.info("DocumentAttributeEditor._createInput()");
                    this._inputDiv = document.createElement('div');
                    this._inputDiv.classList.add("wpt-input", "wpt-input--full");
                    this._input = document.createElement('input');
                    this._inputDiv.appendChild(this._input);
                    this._input.setAttribute('aria-labelledby', this._id);
                    this._input.classList.add('wpt-input__input');
                    this._input.value = this._attribute.Value;
                    this._core.Functions.setInputAbility(this._inputDiv, false, this._input);
                    if (((_a = this._attribute.Document) === null || _a === void 0 ? void 0 : _a.ItemNum) && ((_b = this._attribute.Document) === null || _b === void 0 ? void 0 : _b.ItemNum) != 0) {
                        this._iconDiv = document.createElement('div');
                        this._inputDiv.appendChild(this._iconDiv);
                        this._iconDiv.classList.add('wpt-input__icons', 'wpt-input__icons--last');
                        this._linkSpan = document.createElement('span');
                        this._iconDiv.appendChild(this._linkSpan);
                        this._linkSpan.classList.add("wpt-input__icons-item", "wpt-input__icons-item--hover-primary", "wpt-font", "wpt-font-icon_RelatedDoc");
                        this._linkSpan.addEventListener('click', this._docClicked);
                    }
                    this._container.appendChild(this._inputDiv);
                };
                this._getValueString = (value) => {
                    this._log.info("DocumentAttributeEditor._getValueString()");
                    let valueString = "0";
                    if (value && value != 0) {
                        valueString = value.toString(10);
                    }
                    return valueString;
                };
                this._docClicked = () => {
                    this._log.info("DocumentAttributeEditor._docClicked()");
                    if (this._callbacks.DocumentLinkCallback) {
                        this._callbacks.DocumentLinkCallback(this._currentValue);
                    }
                };
                this._originalValue = this._getValueString((_a = this._attribute.Document) === null || _a === void 0 ? void 0 : _a.ItemNum);
                this._currentValue = this._originalValue;
                this._createInput();
            }
        }
        class RelationAttributeEditor extends AttributeEditor {
            constructor(core, form, container, id, attribute, callbacks = {}, edit = WorkViewEditMode.READONLY) {
                var _a, _b;
                super(core, form, container, id, attribute, callbacks, edit);
                this._inputDiv = null;
                this._searchDiv = null;
                this._display = null;
                this._searchInput = null;
                this._iconDiv = null;
                this._searchIconDiv = null;
                this._linkSpan = null;
                this._deleteSpan = null;
                this._linkedObject = null;
                this._displayDatatype = null;
                this.getChangedValue = () => {
                    this._log.info("RelationAttributeEditor.getChangedValue()");
                    if (this._originalValue != this._currentValue) {
                        let result = {
                            Name: this._attribute.Name,
                            DataType: this._attribute.DataType,
                            Value: this._currentValue
                        };
                        return result;
                    }
                    return null;
                };
                this.setValue = (value) => {
                    this._log.info("RelationAttributeEditor.setValue()");
                    console.warn("setValue() not supported for Relation attributes");
                };
                this.setRelation = (objectId, displayValue, displayDatatype) => {
                    this._log.info("RelationAttributeEditor.setRelation()");
                    this._currentValue = objectId;
                    this._displayDatatype = displayDatatype;
                    this._display.value = this._getDisplayValue(displayValue, displayDatatype);
                    if (this.IsEditable) {
                        this._searchInput.value = "";
                        if (objectId == "0") {
                            this._linkedObject = null;
                            this._core.Functions.hideElement(this._deleteSpan);
                        }
                        else {
                            this._linkedObject = {
                                Application: this._attribute.Relation.ApplicationName,
                                Class: this._attribute.Relation.TargetClassName,
                                ObjectId: new Number(objectId).valueOf()
                            };
                            this._core.Functions.showElement(this._deleteSpan);
                        }
                        this._relationChanged();
                    }
                };
                this._allowEditing = () => {
                    this._log.info("RelationAttributeEditor._allowEditing()");
                    if (this._linkedObject) {
                        this._core.Functions.showElement(this._deleteSpan);
                        this._core.Functions.hideElement(this._linkSpan);
                    }
                    // switching between display and editing inputs
                    this._core.Functions.showElement(this._searchDiv);
                };
                this._createInput = () => {
                    var _a, _b;
                    this._log.info("RelationAttributeEditor._createInput()");
                    this._inputDiv = document.createElement('div');
                    this._inputDiv.classList.add("wpt-input", "wpt-input--full");
                    this._display = document.createElement('input');
                    this._inputDiv.appendChild(this._display);
                    this._display.setAttribute('aria-labelledby', this._id);
                    this._display.classList.add('wpt-input__input');
                    this._display.type = 'text';
                    this._display.value = this._getDisplayValue((_a = this._attribute.Relation) === null || _a === void 0 ? void 0 : _a.DisplayValue, this._displayDatatype);
                    this._core.Functions.setInputAbility(this._inputDiv, false, this._display);
                    this._iconDiv = document.createElement('div');
                    this._inputDiv.appendChild(this._iconDiv);
                    this._iconDiv.classList.add('wpt-input__icons', 'wpt-input__icons--last');
                    this._linkSpan = document.createElement('span');
                    this._iconDiv.appendChild(this._linkSpan);
                    this._linkSpan.classList.add("wpt-input__icons-item", "wpt-input__icons-item--hover-primary", "wpt-font", "wpt-font-icon_Link", WPTNamespace.HIDDEN_CLASS);
                    this._linkSpan.addEventListener('click', this._linkClicked);
                    if (((_b = this._attribute.Relation) === null || _b === void 0 ? void 0 : _b.TargetId) && this._attribute.Relation.TargetId != 0) {
                        this._linkedObject = {
                            Application: this._attribute.Relation.ApplicationName,
                            Class: this._attribute.Relation.TargetClassName,
                            ObjectId: this._attribute.Relation.TargetId
                        };
                        this._core.Functions.showElement(this._linkSpan);
                    }
                    this._container.appendChild(this._inputDiv);
                    if (this.IsEditable) {
                        this._deleteSpan = document.createElement('span');
                        this._iconDiv.appendChild(this._deleteSpan);
                        this._deleteSpan.classList.add("wpt-input__icons-item", "wpt-input__icons-item--hover-error", "wpt-font", "wpt-font-icon_Trash", WPTNamespace.HIDDEN_CLASS);
                        this._deleteSpan.addEventListener('click', this._clearRelation);
                        this._searchDiv = document.createElement('div');
                        this._searchDiv.classList.add("wpt-input", "wpt-input--full", WPTNamespace.HIDDEN_CLASS);
                        this._searchInput = document.createElement('input');
                        ;
                        this._searchDiv.appendChild(this._searchInput);
                        this._searchInput.setAttribute('aria-labelledby', this._id);
                        this._searchInput.classList.add('wpt-input__input');
                        this._searchInput.type = 'text';
                        this._searchInput.value = "";
                        this._core.Helper.setElementTranslationAttribute(this._searchInput, 'placeholder', 'STR_WPT_WV_SEARCH_RELATED');
                        this._searchInput.addEventListener('keyup', this._searchEnter);
                        this._searchIconDiv = document.createElement('div');
                        this._searchDiv.appendChild(this._searchIconDiv);
                        this._searchIconDiv.classList.add('wpt-input__icons', 'wpt-input__icons--last');
                        let searchSpan = document.createElement('span');
                        this._searchIconDiv.appendChild(searchSpan);
                        searchSpan.classList.add("wpt-input__icons-item", "wpt-input__icons-item--hover-primary", "wpt-font", "wpt-font-icon_Search");
                        searchSpan.addEventListener('click', this._searchRelation);
                        this._container.appendChild(this._searchDiv);
                    }
                };
                this._getDisplayValue = (value, datatype) => {
                    this._log.info("RelationAttributeEditor._getDisplayValue()");
                    let displayValue = value;
                    switch (datatype) {
                        case 'Date':
                            displayValue = "";
                            if (value != "") {
                                displayValue = this._core.OBHelper.formatDate(value);
                            }
                            break;
                        case 'DateTime':
                            displayValue = "";
                            if (value != "") {
                                displayValue = this._core.OBHelper.formatDatetime(value);
                            }
                            break;
                        case 'Integer':
                        case 'Float':
                        case 'Decimal':
                            displayValue = "";
                            if (value != "") {
                                displayValue = this._core.OBHelper.formatNumber(value);
                            }
                            break;
                        case 'Currency':
                            displayValue = "";
                            if (value != "") {
                                displayValue = this._core.OBHelper.formatCurrency(value);
                            }
                            break;
                        default:
                            break;
                    }
                    return displayValue;
                };
                this._getValueString = (value) => {
                    this._log.info("RelationAttributeEditor._getValueString()");
                    let valueString = "0";
                    if (value && value != 0) {
                        valueString = value.toString(10);
                    }
                    return valueString;
                };
                this._linkClicked = () => {
                    this._log.info("RelationAttributeEditor._linkClicked()");
                    if (this._callbacks.RelationLinkCallback) {
                        this._callbacks.RelationLinkCallback(this._linkedObject);
                    }
                };
                this._searchEnter = (event) => {
                    this._log.trace("RelationAttributeEditor._searchEnter()");
                    if (event.key === 'Enter') {
                        this._searchRelation(null);
                    }
                };
                this._searchRelation = (event) => {
                    this._log.info("RelationAttributeEditor._searchRelation()");
                    event === null || event === void 0 ? void 0 : event.preventDefault();
                    if (this._callbacks.RelationSearchCallback) {
                        let requestResult = {
                            Application: this._attribute.Relation.ApplicationName,
                            Class: this._attribute.Relation.RelatedClassName,
                            SearchValue: this._searchInput.value,
                            SearchAttribute: this._attribute.Relation.RequestedName
                        };
                        this._callbacks.RelationSearchCallback(this._attribute.Name, requestResult, this._callbacks.RelationSetCallback);
                    }
                };
                this._clearRelation = (event) => {
                    this._log.info("RelationAttributeEditor._clearRelation()");
                    event.preventDefault();
                    if (this._callbacks.RelationClearedCallback) {
                        this._callbacks.RelationClearedCallback(this._attribute.Name);
                    }
                    else {
                        this._currentValue = "0";
                        this._display.value = "";
                        this._relationChanged();
                    }
                };
                this._relationChanged = () => {
                    this._log.info("RelationAttributeEditor._relationChanged()");
                    this._checkValidity();
                    if (this._originalValue != this._currentValue) {
                        if (this._callbacks.DataChangedCallback) {
                            this._callbacks.DataChangedCallback();
                        }
                    }
                };
                this._checkValidity = () => {
                    this._log.info("RelationAttributeEditor._checkValidity()");
                    if (this._attribute.Required && this._currentValue == "0") {
                        this._searchInput.setCustomValidity("STR_WPT_WV_RELATION_REQUIRED");
                    }
                    else {
                        this._searchInput.setCustomValidity("");
                    }
                };
                this._originalValue = this._getValueString((_a = this._attribute.Relation) === null || _a === void 0 ? void 0 : _a.RelatedId);
                this._currentValue = this._originalValue;
                this._displayDatatype = (_b = this._attribute.Relation) === null || _b === void 0 ? void 0 : _b.DisplayDataType;
                this._createInput();
            }
        }
        MetadataEditors.RelationAttributeEditor = RelationAttributeEditor;
    })(MetadataEditors = WPTNamespace.MetadataEditors || (WPTNamespace.MetadataEditors = {}));
})(WPTNamespace || (WPTNamespace = {}));
